/// <reference types="vite-plugin-pwa/client" />

import { useRegisterSW } from 'virtual:pwa-register/react'

export function ReloadPrompt() {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r: any) {
      console.log('SW Registered: ', r)
      
      // Periodically check for updates (every 1 minute)
      if (r) {
        setInterval(() => {
          console.log('Checking for SW updates...')
          r.update()
        }, 60000)
      }
    },
    onRegisterError(error: any) {
      console.log('SW registration error', error)
    },
  })

  const close = () => {
    setOfflineReady(false)
    setNeedRefresh(false)
  }

  if (!offlineReady && !needRefresh) return null

  return (
    <div className="fixed bottom-4 right-4 z-50 m-0 p-4 rounded bg-background border border-border shadow-lg flex flex-col gap-2 max-w-sm">
      <div className="text-sm">
        {offlineReady ? (
          <span>App ready to work offline</span>
        ) : (
          <span>New version available, click on reload button to update.</span>
        )}
      </div>
      <div className="flex gap-2 justify-end">
        {needRefresh && (
          <button 
            className="px-3 py-1 text-sm bg-primary text-primary-foreground rounded hover:bg-primary/90" 
            onClick={async () => {
              try {
                await updateServiceWorker(true)
              } catch (e) {
                console.error('SW update failed', e)
              }
              // Fallback to force reload if updateServiceWorker(true) doesn't auto-reload
              setTimeout(() => {
                window.location.reload()
              }, 300)
            }}
          >
            Reload
          </button>
        )}
        <button 
          className="px-3 py-1 text-sm border border-border rounded hover:bg-muted" 
          onClick={() => close()}
        >
          Close
        </button>
      </div>
    </div>
  )
}
